<template>
  <div
      class="tw-h-[300px] tw-whitespace-nowrap tw-overflow-y-auto tw-text-center tw-overflow-x-hidden"
      :class="scrollbarClasses"
      ref="container"
  >
    <!-- Company Fonts Section -->
    <div v-if="processedCompanyFonts.length" class="tw-font-section">
      <div class="section-header tw-text-left tw-px-4 tw-py-2 tw-bg-gray-100 tw-font-bold">
        Company Fonts
      </div>
      <div
          v-for="(font, i) in processedCompanyFonts"
          :key="'company-' + i"
          :class="{
          'fontElement tw-h-[30px]': true,
          middleChild: font.fontFamily === selectedElement?.fontFamily,
        }"
          :style="{ fontFamily: font.fontFamily }"
          @click="selectFont"
      >
        {{ font.displayName }}
      </div>
    </div>

    <!-- System & Default Fonts Section -->
    <div class="tw-font-section">
      <div class="section-header tw-text-left tw-px-4 tw-py-2 tw-bg-gray-100 tw-font-bold">
        System Fonts
      </div>
      <div
          v-for="(font, i) in defaultFonts"
          :key="'default-' + i"
          :class="{
          'fontElement tw-h-[30px]': true,
          middleChild: font === selectedElement?.fontFamily,
        }"
          :style="{ fontFamily: font }"
          @click="selectFont"
          ref="fonts"
      >
        {{ font }}
      </div>
    </div>
    <div class="tw-h-[130px]"></div>
  </div>
</template>

<script>
import allFonts from "@/constants/allFonts";
import systemFonts from "@/constants/systemFonts";
import { scrollbarClasses } from "@/utils/tailwindScrollbarClasses";

export default {
  setup() {
    return {
      scrollbarClasses
    };
  },
  props: {
    selectedElement: {
      type: Object,
    },
    companyFonts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    processedCompanyFonts() {
      return this.companyFonts.map((font) => ({
        fontFamily: this.getFontFamilyName(font.name),
        displayName: this.getFontDisplayName(font.name),
        path: font.path,
      }));
    },
    defaultFonts() {
      return [ ...systemFonts, ...allFonts ].sort((a, b) => a.localeCompare(b));
    },
  },
  mounted() {
    this.$refs.container.scrollTo({ top: 100 });
    this.loadCompanyFonts();
  },
  methods: {
    getFontFamilyName(filename) {
      return filename.replace(/\.[^/.]+$/, "").replace(/[^a-zA-Z0-9]/g, "");
    },
    getFontDisplayName(filename) {
      return filename.replace(/\.[^/.]+$/, "");
    },
    loadCompanyFonts() {
      this.processedCompanyFonts.forEach((font) => {
        const style = document.createElement("style");
        style.textContent = `
          @font-face {
            font-family: '${font.fontFamily}';
            src: url('${font.path}') format('truetype');
          }
        `;
        document.head.appendChild(style);
      });
    },
    selectFont(e) {
      let fontFamily = e.target.style.fontFamily.replace(/['"]+/g, "");
      this.$emit("onFontSelected", fontFamily);

      // Update middle child styling
      const elements = this.$el.getElementsByClassName("fontElement");
      Array.from(elements).forEach((el) => el.classList.remove("middleChild"));
      e.target.classList.add("middleChild");
    },
  },
  watch: {
    companyFonts: {
      handler() {
        this.loadCompanyFonts();
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss">
#cardDesigner {
  .fontElement {
    opacity: 0.5;
    box-sizing: border-box;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    color: white;;

    &:hover {
      opacity: 0.9;
      background: #f5f5f5;
      color: black;
    }
  }

  .middleChild {
    scale: 1.2;
    opacity: 1;
    transition: 0.5s ease-out;
    background: #ccc;
    color: black;
  }

  .font-section {
    margin-bottom: 1rem;
  }
}
</style>
